// extracted by mini-css-extract-plugin
export default {"step_text":"step_step_text__KbX93"};